<template>
    <v-form ref="formulario">
        <v-card flat class="fill-height">
            <v-card-text>
                <v-layout wrap>

                    <v-flex xs12>
                        <provider-title title="Cobrar"/>
                    </v-flex>

                    <v-flex xs12>
                        <div class="my-4" v-if="!allowOnlinePayments">
                            <div class="body-2"> Tu plan actual no incluye cobros en línea.</div>
                            <div class="mt-2" v-if="allowVC">
                                ¿Necesitas esta característica?
                                <br/>
                                <buy-new-plan-btn/>
                            </div>
                        </div>
                        <template v-else>
                            <v-switch
                                color="primary"
                                prepend-icon="fa-credit-card"
                                label="Cobrar atención en línea"
                                v-model="request_online_payment"
                                hide-details
                            ></v-switch>

                            <v-slide-y-transition>
                                <div v-show="request_online_payment">
                                    <v-layout wrap>
                                        <v-flex xs10 mt-3>
                                            <v-text-field
                                                :hint="hint"
                                                ref="paymentUrl"
                                                @focus="$event.target.select(); hint = ''"
                                                label="Link de cobro"
                                                v-model="payment_url"
                                            />
                                        </v-flex>
                                        <v-flex xs2 mt-3>
                                            <v-btn :fab="isMobile" class="mx-1" color="default" round small depressed outline @click="copyLink" :disabled="!payment_url">
                                                <v-icon size="18" :class="!isMobile ? 'mr-2' : ''">fa-link</v-icon>
                                                <span v-if="!isMobile">copiar</span>
                                            </v-btn>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-text-field
                                                hide-details outline
                                                label="Valor de link de cobro"
                                                :value="payment_price | number"
                                                @input="value => payment_price = value"
                                            />
                                        </v-flex>
                                    </v-layout>
                                </div>
                            </v-slide-y-transition>
                        </template>
                    </v-flex>

                    <v-flex xs12>
                        <v-divider class="my-3"/>
                        <provider-title title="Video Llamada"/>
                    </v-flex>
                    <v-flex xs12 class="mt-0 pt-0">

                        <div class="my-4" v-if="!allowVC">
                            <div class="body-2"> Tu plan actual no incluye atención por videollamada.</div>
                            <div class="mt-2" v-if="allowOnlinePayments">
                                ¿Necesitas esta característica?
                                <br/>
                                <buy-new-plan-btn/>
                            </div>
                        </div>

                        <v-switch
                            v-else
                            color="primary"
                            prepend-icon="fa-video"
                            label="Permitir atención por video"
                            v-model="allow_vc"
                            hide-details
                        ></v-switch>

                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions v-if="allowVC || allowOnlinePayments">
                <v-spacer/>
                <v-btn color="primary" @click="submit" :loading="loading">
                    Guardar
                </v-btn>
            </v-card-actions>
            <template v-else>
                <v-divider/>
                <div class="text-xs-center mt-3">
                    ¿Necesitas alguna de estas características?
                    <br/>
                    <buy-new-plan-btn/>
                </div>
            </template>
        </v-card>
    </v-form>
</template>

<script>

import {mapState, mapMutations, mapGetters} from 'vuex'
import {ApiUtils} from '@/utils/ApiUtils'

export default {
    components: {
        BuyNewPlanBtn: () => import('@/components/subscription/BuyNewPlanBtn'),
        ProviderTitle: () => import('@/components/providers/panel/ProviderTitle')
    },
    data() {
        return {
            loading: false,
            error: '',
            allow_vc: false,
            request_online_payment: false,
            payment_url: '',
            hint: '',
            payment_price: 0,
        }
    },
    computed: {
        ...mapState(['currentUser', 'currentProvider']),
        ...mapGetters(['allowOnlinePayments', 'allowVC', 'specialistSettings']),
        isOwner(vm = this) {
            return !!vm.currentProvider && vm.currentProvider.role.is_owner
        },
        payload(vm = this) {
            return {
                allow_vc: vm.allow_vc ? 1 : 0,
                request_online_payment: vm.request_online_payment ? 1 : 0,
                payment_url: vm.payment_url,
                payment_price: Number(vm.payment_price.toString().replaceAll('.', ''))
            }
        }
    },
    mounted() {
        this.loadDefault()
    },
    methods: {
        ...mapMutations(['showSnackBar']),
        loadDefault() {
            const vm = this
            const specialistSettings = vm.specialistSettings
            vm.allow_vc = !!specialistSettings && specialistSettings.allow_vc
            vm.request_online_payment = !!specialistSettings && specialistSettings.request_online_payment || false
            vm.payment_url = !!specialistSettings && specialistSettings.payment_url || null
            vm.payment_price = !!specialistSettings && specialistSettings.payment_price || 0
        },
        async submit() {
            const vm = this
            vm.error = ''
            if (vm.loading || !vm.currentProvider) return
            if (vm.request_online_payment && (!vm.payment_url || !vm.payment_price))
                return vm.showSnackBar('Para cobrar en linea debe completar el link de cobro con su valor');
            const {id} = vm.currentProvider
            vm.loading = true
            const response = await ApiUtils.makePatch(`provider/${id}/settings/specialist`, null, vm.payload)
            vm.loading = false

            if (!response.ok) {
                const json = await response.json()
                vm.error = json.message || 'Ocurrió un error intentando guardar la configuración'
                return vm.showSnackBar({text: vm.error, color: 'error'})
            }

            vm.showSnackBar({text: 'Configuración actualizada', color: 'success'})
            await ApiUtils.fetchMe()
        },
        copyLink(){
            const vm = this
            vm.$refs.paymentUrl.focus()
            document.execCommand("copy");
            vm.hint = '¡Link de cobro copiado!'
        },
    },
    watch: {
        request_online_payment(val) {
            if (!val) {
                this.payment_url = ''
                this.payment_price = 0
            }
        }
    }
}
</script>
<style scoped>


</style>